export const API_BASE_URL = 'https://numdleapi.vercel.app';
